(function(){
    angular.module('tmx-app').directive("tmxSelect", tmxSelect);

    function tmxSelect() {
        return {
            scope:{
                name: "@",
                value:'=',
                onChange:'&',
                blur:'&',
                //name: '@',
                placeholder: "@",
                required: "@",
                disabled: "=",
                noCache:"=",
                options:"=",//An array of options
                readonly:"@",
                showerror: '=',
                errormsg: '=',
                form: "=",
                dynamicField:'=',
                dynamicShow:'=',
                formula:'@',
                hasFormula:'@',
                parameters:'=',
                helpText: '@',
                selectFirst:'@'
            },
            require :"ngModel",
            restrict: 'E',
            // replace: true,
            priority: 100,
            templateUrl: 'common/directives/tmxselect/tmxselect.html',
            controller: tmxSelectCtrl,
            controllerAs:'selectCtrl'
        };
    }

/*      selectCtrl.scope._onChange=function(selectedItem){
            if(angular.isDefined(selectedItem) && selectedItem!=null){
                selectCtrl.scope.value=selectedItem;
                if(angular.isFunction(selectCtrl.scope.onChange()))selectCtrl.scope.onChange()(selectedItem.hiddenAttr);        
            }else{
                if(angular.isFunction(selectCtrl.scope.onChange()))selectCtrl.scope.onChange()(undefined);
            }
        }*/

    function tmxSelectCtrl($scope,$element,$attrs){
        var self=this;
        self.scope = $scope;
        angular.element(this).addClass("tmx-select");

        $element.on("focusout", function(event){
            if(event.relatedTarget === null || event.relatedTarget.tagName !== "LI") {
                if(self.querySearch(self.searchText).length == 0) {
                    self.searchText = "";
                }
                else if(self.searchText){
                    var isfound = false;
                    if(angular.isDefined(self.items)) {
                        for (i = 0; i < self.items.length; i++) {
                            if(angular.lowercase(self.searchText) === angular.lowercase(self.items[i].Label)) {
                                isfound = true;
                                break;
                            }
                        }
                    }
                    else
                        return;
                    if(!isfound){
                        self.searchText = "";
                    }
                }
            }
        });
        //////////////////////////////////////////////
        self.selectFirst=false;
        if(angular.isDefined(self.scope.selectFirst)) {
            if(self.scope.selectFirst=="true" || self.scope.selectFirst==true) {
                if($scope.options.length > 0 && !angular.isDefined($scope.value) || $scope.value == null){
                    if(angular.isDefined($scope.options[0].LookupId)) {
                        $scope.value = $scope.options[0].LookupId;                
                    }
                    else{
                        $scope.value = $scope.options[0].HiddenValue;                
                    }
                }
            }
        }
        //////////////////////////////////////////////
        self.readonly=false;
        if(angular.isDefined(self.scope.readonly)) {
            if(self.scope.readonly=="true") {
                self.readonly=true;
            }
        }
        ///////////////////////////////////////////////
        self.clear= function() {
            self.searchText = "";
            //explicitly set $touched to true as was previously touched and if required is present then display error
            if(angular.isDefined(self.scope.form)){
                self.scope.form[self.scope.name].$touched = true;
            }

        };
        self.isDisabled=function(){
            return self.scope.readonly=="true" || self.scope.disabled==true  ;
        }
        self.setFocus=function() {
            $element.find("input").focus();
        };


        self.querySearch=function (query) {
            var results = query ? $scope.options.filter( createFilterFor(query) ) : $scope.options;
            if(results) {
                return results;
            }
            else
                return "";
          
        }
        
        self.searchTextChange=function(text) {
        }

        self.onchange=function(item){
            if(angular.isFunction($scope.onChange())){
                $scope.onChange()($scope.value,$scope,$scope.parameters);
                $scope.$emit("SelectChangeEvent",{form_name:$scope.form?$scope.form.$name:""}); 
            }
        }

        self.selectedItemChange=function(item) {
            if(self.fromPreSelect){
                self.fromPreSelect=false;
            }
            else if(angular.isDefined(item) && item!=null){
                if($scope.value!=item.LookupId || $scope.value!=item.HiddenValue){
                    if(item.LookupId)
                        $scope.value=item.LookupId;
                    else if(item.HiddenValue)
                        $scope.value=item.HiddenValue;
                    self.changeDueToSelfFunc=true;
                }
            }
            else{
                if(angular.isDefined($scope.value) && $scope.value!=null ){
                    $scope.value=null;  
                    self.changeDueToSelfFunc=true;
                }
                if(angular.isDefined(self.searchText) && self.searchText!=null && self.searchText!==""){
                    self.searchText="";
                }
            }
            
            self.onchange(item);
        };


        function getValue(){
            return $scope.value;
        }


        function updateSelectedItem(newValue, oldValue){
            if(self.changeDueToSelfFunc){
                self.changeDueToSelfFunc=false;
                return;
            }
            if(!angular.isDefined(newValue) || newValue===null){
                self.selectedItem=undefined;
                return;
            }
            function selectItem(item){
                if(item.LookupId==newValue || item.HiddenValue==newValue){
                    self.selectedItem=item;
                }
            }
            if(angular.isDefined($scope.options) && angular.isArray($scope.options))
                $scope.options.forEach(selectItem);
        }
      
        
        function hasValidOptions(){
            //return angular.isDefined($scope.options) && $scope.options!=null && angular.isArray($scope.options);
            if (!(angular.isDefined($scope.options) && $scope.options!=null && angular.isArray($scope.options) && $scope.options.length>0))return -1;
            return $scope.options.length;
        }

        function preSelect(options){
            options.forEach(
                function(option){
                    if(option.LookupId==$scope.value || option.HiddenValue==$scope.value){
                        self.selectedItem=option;
                        self.fromPreSelect=true;
                    }

                }
            );
        }

        function preselectIfValue(newValue, oldValue){
            if(newValue!==oldValue && newValue>0){
                if(angular.isDefined($scope.value) && $scope.value!=null){
                    preSelect($scope.options);
                }
            }
        }
        $scope.$watch(getValue,updateSelectedItem);
        $scope.$watch(hasValidOptions,preselectIfValue);

        $scope.hideRegularMessages=function(){
            return angular.isDefined($scope.dynamicField);
        }

        //if it is a formula driven value
        if(angular.isDefined($scope.hasFormula) && $scope.hasFormula=="true"){
            bindValueWithFormula();
        }
        function bindValueWithFormula(){
            function get(){
                return $scope.formula;
            }

            function update(f1,f2){
                if(f1!=f2){
                    $scope.value=f1;
                }
            }
            update($scope.formula);
            $scope.$watch(get,update);
        }
        /*var dynamic_patch=true;//we want the watch to change for sure the first time;

        function montiorDynamicField(){
            if(dynamic_patch){
                dynamic_patch=!dynamic_patch;
                return !(!$scope.dynamicField.isValid && $scope.dynamicShow);//inverse of condition below, to make sure it differs the next time montior is called
            }
            return !$scope.dynamicField.isValid && $scope.dynamicShow;// return true if field not valid and error messages are enabled
        }

        function updateInputColor(newValue,oldValue){
            try{
                if(newValue){
                    $scope.form[$scope.dynamicField.form_name].$setValidity("required", false);
                    $scope.form[$scope.dynamicField.form_name].$setTouched(true);
                }else{
                    $scope.form[$scope.dynamicField.form_name].$setValidity("required", true);
                    $scope.form[$scope.dynamicField.form_name].$setTouched(false);
                }
            }
            catch(e){
                dynamic_patch=true;
            }
        }

        if(angular.isDefined($scope.dynamicField) && angular.isDefined($scope.dynamicShow)){
            $scope.$watch(montiorDynamicField,updateInputColor);
        }*/
    }


    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(item){
            return (item.VisibleValue.toLowerCase().indexOf(lowercaseQuery) >= 0);
        };
    }


})();